// extracted by mini-css-extract-plugin
export default {"validation-error":"filter-decimal__validation-error--nyddL","validationError":"filter-decimal__validation-error--nyddL","input":"filter-decimal__input--zSRQe"};